var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('editor',{attrs:{"docCreate":_vm.docCreate,"initial":_vm.dataItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }